import type { FileRejection } from "react-dropzone"

export function getFileRejectionErrorMessage(rejection: FileRejection): string {
  const errorMessages = rejection.errors.map(error => error.message).join(", ")
  return `${rejection.file.name}: ${errorMessages}`
}
